import { UndoRedoSystem } from '@aninix-inc/model'
import { useProject } from '@aninix/core'

export const useUndoRedo = () => {
  const project = useProject()
  const undoRedo = project.getSystemOrThrow(UndoRedoSystem)
  return undoRedo
}
